import React, { Component } from 'react';
import PropTypes from 'prop-types';
import cx from 'classnames';
import { isEmpty } from 'lodash-es';

import { SortableTable } from '../../components/SortableTable';
import SwitchButtons from '../../components/SwitchButtons';
import QuickViewContext from '../../components/QuickView/QuickViewContext';

class DashboardTable extends Component {
  static propTypes = {
    columns: PropTypes.arrayOf(PropTypes.object).isRequired,
    rows: PropTypes.func,
    tableName: PropTypes.string.isRequired,
    iconClasses: PropTypes.string.isRequired,
    defaultSortBy: PropTypes.string,
    sortOrder: PropTypes.string,
    className: PropTypes.string,
    withKindButtons: PropTypes.bool,
  }
  static contextType = QuickViewContext;

  state = {
    kind: 'free',
  }

  handleKindChange = (kind) => {
    this.setState({ kind });
  }

  render() {
    const {
      tableName, iconClasses, columns, rows,
      withKindButtons, defaultSortBy, sortOrder, className,
    } = this.props;
    const { kind } = this.state;
    const permissions = !isEmpty(this.context) ? { onAppQuickViewOpen: this.context.onAppQuickViewOpen, onPubQuickViewOpen: this.context.onPubQuickViewOpen } : {};
    return (
      <div className="col-md-6">
        <div className="card card-sm b-rds b-a">
          <div className="d-flex align-items-center flex-wrap mb-xs">
            <div className="flex-grow d-flex align-items-center text-md mb-xs m-r">
              <i className={cx('mr-xxs', iconClasses)} />
              <h4>{tableName}</h4>
            </div>
            {withKindButtons &&
              <SwitchButtons
                options={[
                  { text: 'Free', value: 'free' },
                  { text: 'Paid', value: 'paid' },
                  { text: 'Grossing', value: 'grossing' },
                ]}
                active={kind}
                size="xs"
                onChange={this.handleKindChange}
              />
            }
          </div>
          <div className="table-responsive">
            <SortableTable
              defaultSortBy={defaultSortBy}
              sortOrder={sortOrder}
              tableClassName={cx('table-default', className)}
              theadClassName="thead-gray"
              columns={columns}
              rows={rows({ kind, ...permissions })}
              hasShowMoreCell={false}
              initialRowsLimit={6}
            />
          </div>
        </div>
      </div>
    );
  }
}

export default DashboardTable;
